// RegisterExistingUser.js - Contains the CompleteRegistration component for handling existing member registration.
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { RegisterExistingMember } from '../services/authAPI';
import { AuthContext } from '../contexts/AuthContext';

function CompleteRegistration() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { logout, isLoggedIn } = useContext(AuthContext);
  
  // Get token from query params
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  
  useEffect(() => {
    // Make sure we have a token
   if (!token) {
  setTimeout(() => {
    setError("No registration token provided.");
  }, 300); // 300ms delay
  return;
}

const existingMember = async () => {
  try {
    const response = await RegisterExistingMember(token);
    if (response && response.success) {
      if (isLoggedIn) {
        logout(true);
      }
      navigate("/login?success=account-added", { replace: true });
    } else {
      setTimeout(() => {
        setError("Registration failed. Please try again.");
      }, 300); // 300ms delay
    }
  } catch (err) {
    setTimeout(() => {
      setError(err.message || "Failed to complete registration.");
    }, 300); // 300ms delay
  }
};
    existingMember();
  }, [token, navigate, logout, isLoggedIn]);
  
  return (
  <>
    {error && (
      <div
        style={{
          color: 'white',
          padding: '12px',
          borderRadius: '4px',
          margin: '16px 0',
          textAlign: 'center',
          fontWeight: 'bold',
        }}
      >
        {error}
      </div>
    )}
  </>
);
}

export default CompleteRegistration;